import type { SYSAction } from "../../../../_ovlclient/src"
import { TableRefresh } from "../../../../_ovlclient/src/library/table/tableapi"

const HookScreenRefresh: SYSAction = async (_) => {
  await TableRefresh("SYSTranslation")
}

const HookScreenNavigateIn: SYSAction = async (_, { global }) => {
  await TableRefresh("SYSTranslation")
}

export let SYSTranslation = {
  hooks: { HookScreenNavigateIn, HookScreenRefresh },
}
